import React, { useState, useRef } from "react";
import PT from "prop-types";
import styled from "styled-components";
import Slider from "react-slick";
import { useI18next, useTranslation } from "gatsby-plugin-react-i18next";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import { down, colors, global, spacings } from "~/src/config/vars";
import { Headline, Container, ScrollAnim } from "~/src/components";

const Slide = ({ image }) => {
    const img = image ? getImage(image) : null;
    return (
        <SSlide>
            <GatsbyImage image={img} alt="Идея" />
        </SSlide>
    );
};

Slide.propTypes = {
    image: PT.object,
};

const SSlide = styled.div`
    width: 100%;
    background-color: ${colors?.bg_light};
    img {
        width: 100%;
        border-radius: ${global?.border_radius_big};
    }
`;

const SETTINGS = {
    dots: false,
    // fade: true,
    infinite: false,
    speed: 200,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
};

const BlockIdeas = ({ ideas_ru, ideas_kg }) => {
    const [index, setIndex] = useState(0);
    const sliderEl = useRef(null);
    const { t } = useTranslation();
    const { language } = useI18next();

    const images_list = language === "ru" ? ideas_ru : ideas_kg;

    return (
        <SBlockIdeas>
            <Container>
                <ScrollAnim type="slideInDownSmall" delay={0}>
                    <Headline size="large" offset={["bottom-20"]}>
                        {t("block_ideas_description")}
                    </Headline>
                </ScrollAnim>
                <SBlock>
                    <ScrollAnim type="slideInDownSmall" delay={0}>
                        <SDots>
                            {images_list
                                ? images_list.edges.map((image, idx) => (
                                      <SDot
                                          key={idx}
                                          onClick={() =>
                                              sliderEl.current.slickGoTo(idx)
                                          }
                                          className={
                                              index === idx ? "active" : ""
                                          }
                                      />
                                  ))
                                : null}
                        </SDots>
                    </ScrollAnim>
                    <ScrollAnim type="slideInDownSmall" delay={0}>
                        <Slider
                            ref={sliderEl}
                            {...SETTINGS}
                            afterChange={(current) => {
                                setIndex(current);
                            }}
                        >
                            {images_list
                                ? images_list.edges.map((image, idx) => (
                                      <Slide key={idx} image={image.node} />
                                  ))
                                : null}
                        </Slider>
                    </ScrollAnim>
                </SBlock>
            </Container>
        </SBlockIdeas>
    );
};

BlockIdeas.propTypes = {
    ideas_ru: PT.object,
    ideas_kg: PT.object,
};

const SBlockIdeas = styled.div`
    padding: ${spacings?.offset_80} 0;
`;

const SBlock = styled.div`
    position: relative;
    width: 100%;
    .slick-slider {
        /* border-radius: ${global?.border_radius_big}; */
        /* overflow: hidden; */
    }
`;

const SDots = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0;
`;

const SDot = styled.div`
    cursor: pointer;
    margin: 0 0 1em 0;
    height: 2em;
    flex: 1;
    position: relative;
    ${down("sm")} {
        height: 1.2em;
        margin: 0 0 0.5em 0;
    }
    &:before {
        content: "";
        transition: all 0.2s;
        background-color: ${colors?.beige_hover};
        width: 100%;
        height: 3px;
        border-radius: 1px;
        display: block;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
    }
    &:hover {
        &:before {
            height: 6px;
        }
    }
    &.active {
        cursor: default;
        &:before {
            height: 5px;
            background-color: ${colors?.violet_base};
        }
    }
`;

export default BlockIdeas;
